import { SVGProps } from 'react';

export const DeleteIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    {...props}
    aria-hidden="true"
    width="11"
    height="13"
    viewBox="0 0 11 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.07593 4.70898C6.90777 4.70898 6.77148 4.84527 6.77148 5.01343V10.7675C6.77148 10.9356 6.90777 11.072 7.07593 11.072C7.24409 11.072 7.38038 10.9356 7.38038 10.7675V5.01343C7.38038 4.84527 7.24409 4.70898 7.07593 4.70898Z"
      fill="#BA2F44"
    />
    <path
      d="M3.48218 4.70898C3.31402 4.70898 3.17773 4.84527 3.17773 5.01343V10.7675C3.17773 10.9356 3.31402 11.072 3.48218 11.072C3.65035 11.072 3.78663 10.9356 3.78663 10.7675V5.01343C3.78663 4.84527 3.65035 4.70898 3.48218 4.70898Z"
      fill="#BA2F44"
    />
    <path
      d="M0.864684 3.87023V11.3712C0.864684 11.8146 1.02725 12.2309 1.31125 12.5297C1.59393 12.8292 1.98734 12.9993 2.39906 13H8.15932C8.57116 12.9993 8.96457 12.8292 9.24713 12.5297C9.53113 12.2309 9.6937 11.8146 9.6937 11.3712V3.87023C10.2582 3.72038 10.624 3.17499 10.5485 2.5957C10.4729 2.01654 9.97947 1.58329 9.39531 1.58317H7.83656V1.20261C7.83834 0.882584 7.71181 0.575282 7.48525 0.349205C7.2587 0.123247 6.95092 -0.00257635 6.63089 4.00021e-05H3.92749C3.60746 -0.00257635 3.29968 0.123247 3.07313 0.349205C2.84657 0.575282 2.72004 0.882584 2.72182 1.20261V1.58317H1.16307C0.578907 1.58329 0.0854856 2.01654 0.00984908 2.5957C-0.0656684 3.17499 0.300146 3.72038 0.864684 3.87023ZM8.15932 12.3911H2.39906C1.87852 12.3911 1.47358 11.9439 1.47358 11.3712V3.89698H9.0848V11.3712C9.0848 11.9439 8.67986 12.3911 8.15932 12.3911ZM3.33072 1.20261C3.3287 1.04409 3.39101 0.891504 3.50352 0.779595C3.6159 0.667687 3.76884 0.606202 3.92749 0.608937H6.63089C6.78954 0.606202 6.94248 0.667687 7.05486 0.779595C7.16737 0.891385 7.22968 1.04409 7.22766 1.20261V1.58317H3.33072V1.20261ZM1.16307 2.19207H9.39531C9.69798 2.19207 9.94332 2.43741 9.94332 2.74008C9.94332 3.04274 9.69798 3.28809 9.39531 3.28809H1.16307C0.860403 3.28809 0.61506 3.04274 0.61506 2.74008C0.61506 2.43741 0.860403 2.19207 1.16307 2.19207Z"
      fill="#BA2F44"
    />
    <path
      d="M5.27905 4.70898C5.11089 4.70898 4.97461 4.84527 4.97461 5.01343V10.7675C4.97461 10.9356 5.11089 11.072 5.27905 11.072C5.44721 11.072 5.58349 10.9356 5.58349 10.7675V5.01343C5.58349 4.84527 5.44721 4.70898 5.27905 4.70898Z"
      fill="#BA2F44"
    />
  </svg>
);
